var _ = require('lodash');
var deepmerge = require('deepmerge');

export const traineeStatusModule = {
  namespaced: true,
  state: {
    viewedIntro: false,
    authorized: false,
    decisionIndex: 0,
    user: {
      traineeId: "1",
      name: "John Doe"
    },
    status: {
      currentScenario: "1",
      currentPlaylist: "1",
      scenarios: {}
    }    
  },
  getters: {
    hasResponse(state) {
      return id => {
        let status = state.status;
        if (status.scenarios[status.currentScenario]) {
          if ( status.scenarios[status.currentScenario].playlists[status.currentPlaylist] ) {
            if ( status.scenarios[status.currentScenario].playlists[status.currentPlaylist].items[id]) {
              return true
            }
          }
        }
        return false
      }
    },
    hasResponseDeep(state) {
      return data => {
        let status = state.status;
        if (status.scenarios[data.sid]) {
          if ( status.scenarios[data.sid].playlists[data.pid] ) {
            if ( status.scenarios[data.sid].playlists[data.pid].items[data.id]) {
              return true
            }
          }
        }
        return false
      }
    },
    getResponse(state) {
      return id => {
        let status = state.status;
        if (status.scenarios[status.currentScenario]) {
          if ( status.scenarios[status.currentScenario].playlists[status.currentPlaylist] ) {
            if ( status.scenarios[status.currentScenario].playlists[status.currentPlaylist].items[id]) {
              return status.scenarios[status.currentScenario].playlists[status.currentPlaylist].items[id].answer
            }
          }
        }
        return ""
      }
    },
    getPlaylistStatus(state) {
      return data => {
        let status = state.status;
        if (status.scenarios[data.sid]) {
          if ( status.scenarios[data.sid].playlists[data.pid] ) {
            if ( status.scenarios[data.sid].playlists[data.pid].completed) {
              return true
            }
          }
        }
        return false
      }
    },
  },
  mutations: {
    runMerge (state, payload) {
      state.status = deepmerge(state.status, payload, {
        arrayMerge: (dest, src) => {
          return _.union(dest, src)
        }
      })
    },
    setSid (state, payload) {
      state.status.currentScenario = payload
    },
    setPid (state, payload) {
      state.status.currentPlaylist = payload
    },
    setViewedIntro (state, payload) {
      state.viewedIntro = payload
    },
    authorize (state, payload) {
      state.authorized = payload
    },
    setDecisionIndex (state, payload) {
      state.decisionIndex = payload
    }
  },
  actions: {
    mergeAnswer (context, payload) {
      let obj =  {
        scenarios: {
          [context.state.status.currentScenario]: {
            playlists: {
              [context.state.status.currentPlaylist]: {
                items: payload
              }
            }
          }
        }
      } 
      context.commit('runMerge', obj)
    },
    finishPlaylist (context) {
      let obj =  {
        scenarios: {
          [context.state.status.currentScenario]: {
            playlists: {
              [context.state.status.currentPlaylist]: {
                completed: true
              }
            }
          }
        }
      } 
      context.commit('runMerge', obj)
    },
    setSid (context, payload) {
      context.commit('setSid', payload)
    },
    setPid (context, payload) {
      context.commit('setPid', payload)
    },
    setViewedIntro (context, payload) {
      context.commit('setViewedIntro', payload)
    },
    authorize (context, payload) {
      context.commit('authorize', payload)
    },
    setDecisionIndex (context, payload) {
      context.commit('setDecisionIndex', payload)
    }
  }
}


//const map = new Map(Object.entries({foo: 'bar'}));